/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import zhTWLocale from '@douyinfe/semi-ui/lib/es/locale/source/zh_TW';

export { default as zhCN } from '@douyinfe/semi-ui/lib/es/locale/source/zh_CN';
export { default as enUS } from '@douyinfe/semi-ui/lib/es/locale/source/en_US';

export const zhTW = zhTWLocale;

export const zhHK = {
  ...zhTWLocale,
  code: 'zh-HK',
  Select: {
    ...zhTWLocale.Select,
    createText: '建立',
  },
  Tree: {
    ...zhTWLocale.Tree,
    searchPlaceholder: '搜尋',
  },
  Upload: {
    ...zhTWLocale.Upload,
    mainText: '點擊以上載檔案，或將檔案拖放到此處',
    illegalTips: '不支援此檔案類型',
    legalTips: '放開以上載檔案',
    replace: '取代檔案',
    clear: '清除',
    selectedFiles: '已選擇檔案',
    illegalSize: '檔案大小不符合規定',
    fail: '上載失敗',
  },
  Typography: {
    ...zhTWLocale.Typography,
    copy: '複製',
    copied: '複製成功',
  },
  Transfer: {
    ...zhTWLocale.Transfer,
    emptySearch: '沒有搜尋結果',
    placeholder: '搜尋',
    clear: '清除',
  },
  TreeSelect: {
    ...zhTWLocale.TreeSelect,
    searchPlaceholder: '搜尋',
  },
  Image: {
    ...zhTWLocale.Image,
    loading: '載入中',
    loadError: '載入失敗',
  },
};
